module.exports = __webpack_public_path__ + "static/media/AllElectric.2b2d565d.svg";